<template>
  <div class="flex items-center">
    <mq-layout
      class="inline-flex items-center"
      :mq="['mobile', 'tablet']">
      <vs-dropdown
        vs-custom-content
        vs-trigger-click
        class="cursor-pointer flex items-center">
        <feather-icon
          :icon="icon"
          class="cursor-pointer"
          svgClasses="h-4 w-4 font-bold"/>
        <vs-dropdown-menu>
          <slot>
            <p class="p-3"
               style="width: 250px; text-wrap: auto">
              {{ text }}
            </p>
          </slot>
        </vs-dropdown-menu>
      </vs-dropdown>
    </mq-layout>
    <mq-layout
      mq="laptopS+"
      class="inline-flex items-center">
      <vs-dropdown
        vs-custom-content
        class="cursor-pointer flex items-center">
        <feather-icon
          :icon="icon"
          class="cursor-pointer"
          svgClasses="h-4 w-4 font-bold"/>
        <vs-dropdown-menu>
          <slot>
            <p class="p-3"
               style="width: 250px; text-wrap: auto">
              {{ text }}
            </p>
          </slot>
        </vs-dropdown-menu>
      </vs-dropdown>
    </mq-layout>
  </div>
</template>

<script>
export default {
  name: 'DropdownTooltip',
  props: {
    icon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
